import isObject from 'lodash/isObject';

export function getTirePrice(price, count) {
  let slabPrice = 0;

  if(isObject(price)){
    let slab = 0;
    Object.keys(price).forEach(i => {
      i =Number(i);
      if(count >= i && i > slab) slab = i;
    });
    slabPrice = price[slab];

  }else{
    slabPrice = price;
  }
  return slabPrice;
}
